import { SiteTypes } from '../enums';
import { getEndpointURL } from './getEndpointUrl';

export const goToBag = () => {
  globalThis.location.href = getEndpointURL(SiteTypes.CART);
};
